/**
 * @function
 */
var genID = (function () {
    var i = 0;
    return function () {
        return i++;
    };
})();


function formatNumber(v, precision = 3) {
    return v.toPrecision(10).replace(/(?:\.0+|(\.\d+?)0+)$/, "$1");
}

function Observable(name) {
    this._name = name;
    this.observers = [];
}

Observable.prototype.name = function (name) {
    if (name === undefined)
        return this._name;

    this._name = name;
    return this;
};

Observable.create = function () {
    return new Observable(...arguments);
};


Observable.new = Observable.create;


Observable.prototype.observe = function (info) {

    var object = info.object === undefined ? null : info.object;
    var ctx = info.ctx === undefined ? info.object : info.ctx;
    var func = info.func === undefined ? function () { } : info.func;
    var topic = info.topic === undefined ? null : info.topic;
    this.observers.push({
        object: object,
        func: func,
        ctx: ctx,
        topic: topic,
        observableName: this.name()
    });

    return this;
};

Observable.prototype.remove = function (object) {
    for (var i = 0; i < this.observers.length; i++) {
        if (object === this.observers[i].object) {
            this.observers.splice(i, 1);
            return true;
        }
    }

    return false;
};
Observable.prototype.notify = function () {
    for (var i in this.observers) {
        var o = this.observers[i];
        var info = arguments.length > 0 ? arguments[0] : {};

        if (o.topic === null || o.topic === info.type) {
            o.func.call(o.ctx, o, ...arguments);
        }

    }
};


function Screen() {
    this._canvas = null;
    this._ctx = null;
    this._w = 0;
    this._h = 0;

    this._screenOrigin = [0, 0];
    this._flip = true;


    this.observable = Observable.create("Screen");
}


Screen.create = function () {
    return new Screen(...arguments);
};
Screen.new = Screen.create;

Screen.prototype.screenOrigin = function (o) {
    if (o === undefined)
        return this._screenOrigin;

    this._screenOrigin = o.concat();

    this.updateValues();
    return this;
};

Screen.prototype.pixelWidth = function () {
    return 1 / this.w();
};

Screen.prototype.updateValues = function () {
    this._v = this._u / this._w * this._h;
    var orig = this.screenOrigin();
    if (this._flip) {
        this._ctx.setTransform(1, 0, 0, -1, orig[0], this.h() - orig[1]);
    } else {
        this._ctx.setTransform(1, 0, 0, 1, orig[0], orig[1]);
    }
    this.observable.notify({
        type: "update",
    });
};
Screen.prototype.aspect = function () {
    return this._w / this._h;
};

Screen.prototype.canvas = function (c) {
    if (typeof c === "undefined")
        return this._canvas;

    this._canvas = c;
    this._w = this._canvas.width;
    this._h = this._canvas.height;
    this._ctx = c.getContext("2d");

    this.updateValues();

    return this;
};

Screen.prototype.clear = function () {
    var ctx = this.ctx();

    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.w(), this.h());


    ctx.restore();
};

Screen.prototype.ctx = function () {
    return this._ctx;
};

Screen.prototype.flip = function (f) {
    if (f === undefined)
        return this._flip;
    this._flip = f;
    this.updateValues();
};

Screen.prototype.w = function (w) {

    if (w === undefined)
        return this._w;

    this._canvas.width = w;
    this._w = w;

    this.updateValues();
    return this;
};

Screen.prototype.h = function (h) {
    if (h === undefined)
        return this._h;

    this._canvas.height = h;
    this._h = h;
    this.updateValues();
    return this;
};



Screen.prototype.toScreen = function (v) {

    const w = this.w();
    const h = this.h();
    return [v[0] * w, v[1] * h];
};

Screen.prototype.toImage = function (v) {

    const w = this.w();
    const h = this.h();
    return [v[0] / w, v[1] / h];
};

Screen.prototype.save = function () {
    this.ctx()
        .save();
};

Screen.prototype.restore = function () {
    this.ctx()
        .restore();
};

Screen.prototype.setColor = function (style, color) {
    this.ctx()[style] = color.toString();
};


/**
 * Use for additional data
 * @class
 * @param {object} [entries] A map of entries
 */
function Data(entries) {
    /**
     * @member
     */
    this.entries = entries !== undefined ? entries : {};
}

/**
 * Creates a new Data instance
 * @function
 * @return {Data}
 * @param {object} [entries] A map of entries
 */
Data.new = function (entries) {
    return new Data(entries);
};
/**
 * Retrieves data for a given key
 * @function
 * @param key
 * @param defaultValue A default value in case the key is not contained
 */
Data.prototype.get = function (key, defaultValue) {
    if (!(key in this.entries)) {
        return defaultValue;
    }
    return this.entries[key];
};


Data.prototype.toJSON = function () {
    return this.entries;
};

/**
 * Sets the value for a key
 * @function
 * @param key
 * @param val
 * @return {Data} this
 *
 */
Data.prototype.set = function (key, val) {
    this.entries[key] = val;
    return this;
};

Data.prototype.remove = function (key) {
    delete this.entries[key];
};
/**
 * Will copy the object and, if the object allows it, copy the values
 * @function
 * @return {Data}
 */
Data.prototype.copy = function () {
    var e = this.entries;
    var keys = Object.keys(e);
    var dn = {};
    for (let i = 0; i < keys.length; i++) {
        var key = keys[i];
        var val = e[key];
        var valCp = val.copy !== undefined ? val.copy() : val;
        dn[key] = valCp;
    }

    return Data.new(dn);
};
/**
 * Will copy the object and, if the object allows it, copy the values
 * Alias for copy function
 * @function
 * @alias Data.prototype.copy
 * @return {Data}
 */
Data.prototype.cp = Data.prototype.copy;

function copy(o) {
    return Object.assign({}, o);
}

export {
    Data,
    Screen,
    Observable,
    genID,
    copy,
    formatNumber
};
